/**
 * Collection of things to import lazily to avoid increasing bundle.
 *
 * This module merely exists to track what libraries we are doing this
 * for.
 *
 * Webpack will automatically create separate chunk .js files for these
 * and download as needed, this helps to reduce the overall initial
 * download size of the app and makes sense for niche features that are
 * only required for specific users and/or pages.
 */

export function importGoogleLibPhonenumber() {
  return import('google-libphonenumber');
}

export function importXlsx() {
  return import('xlsx');
}

export function importLottiePlayer() {
  return import('@lottiefiles/lottie-player');
}

export function importWaveSurfer() {
  return import('wavesurfer.js');
}



// WEBPACK FOOTER //
// ./src/deferredImports.js